export default __webpack_public_path__ + "static/pro@992-02adb5c20ae570c7a9d948e552abae18.webp";